import { lazy, Suspense } from "react";
import CircularLoader from "../customs/loader/main";
const Main = lazy(() => import("../components/singleSignOn/main"));

const SingleSignOn = () => {
  return (
      <Suspense fallback={<CircularLoader />}>
        <Main />
      </Suspense>
  );
};

export default SingleSignOn;
